<div class="switches-wrapper flex-column gap-16">
  <div class="toggle flex-space-between gap-16">
    <mat-label class="b1 font-weight-semibold">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_CONTENT.PATH_CONTENT_PANEL' | bmsTranslate }}</mat-label>
    <mat-slide-toggle [checked]="pathContentPanelEnabled" (change)="onPathContentPanelEnabledChanged($event.checked)"></mat-slide-toggle>
  </div>

  <button mat-stroked-button (click)="viewAllSettings()">{{ 'GENERAL.ACTIONS.VIEW_ALL_SETTINGS' | bmsTranslate }}</button>
</div>
